import { render } from "./KnowledgeVersionCompare.vue?vue&type=template&id=508c8c6c&scoped=true"
import script from "./KnowledgeVersionCompare.vue?vue&type=script&lang=js"
export * from "./KnowledgeVersionCompare.vue?vue&type=script&lang=js"

import "./KnowledgeVersionCompare.vue?vue&type=style&index=0&id=508c8c6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508c8c6c"]])

export default __exports__